import { render, staticRenderFns } from "./BreakpointDebugger.vue?vue&type=template&id=4577f882&scoped=true&"
import script from "./BreakpointDebugger.vue?vue&type=script&lang=js&"
export * from "./BreakpointDebugger.vue?vue&type=script&lang=js&"
import style0 from "./BreakpointDebugger.vue?vue&type=style&index=0&id=4577f882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577f882",
  null
  
)

export default component.exports